export const ServiceUrls = {

  MAIN_SERVICE: process.env.REACT_APP_API_URL,

  VOICE_SERVICE: process.env.REACT_APP_VOICE_API_URL,

  USER_FEED_SERVICE: process.env.REACT_APP_USER_FEED_API_URL,

  COLLEGE_SERVICE: process.env.REACT_APP_COLLEGE_API_URL,

  COLLEGE_LISTING_SERVICE: process.env.REACT_APP_COLLEGE_LISTING_API_URL,

  LEARN_SERVICE: process.env.REACT_APP_LEARN_API_URL,

  SCHOOL_SERVICE: process.env.REACT_APP_SCHOOL_API_URL,

  GET_ARTICLE_AUDIO_API: process.env.REACT_APP_GET_ARTICLE_AUDIO_API_URL,

  GET_USER_FEED_GENERATION_API: process.env.REACT_APP_GET_USER_FEED_GENERATION_API_URL,

  POST_LMS_PRODUCT_STATUS_API: process.env.REACT_APP_POST_LMS_PRODUCT_STATUS_API_URL,

  POST_LMS_REGISTER_API: process.env.REACT_APP_POST_LMS_REGISTER_API_URL,

  COACHING_SERVICE: process.env.REACT_APP_COACHING_API_URL,

  COUNTRY_SERVICE: process.env.REACT_APP_COUNTRY_API_URL,

  CONTACT_USER_SERVICE: process.env.REACT_APP_CONTACT_USER_API_URL,

  CP_FEEDBACK_SERVICE: process.env.REACT_APP_CP_FEEDBACK_API_URL,
  
  CUS_SERVICE:process.env.REACT_APP_CUS_SERVICE,

  CLEVERTAP_DELETE_PROFILE_SERVICE: "https://eu1.api.clevertap.com",

  TOOLSHUB_SERVICE:process.env.REACT_APP_TOOLSHUB_SERVICE,
};
  
